'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Abacus = require('./Abacus');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Abacus).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Abacus/index.js
// module id = 1084
// module chunks = 1